const [ w, d, mq ] = [window, document, window.matchMedia( "(max-width: 989px)" ) ];

const lpNav =  `
  <ul class="nav_list list-menu list-menu--inline">
    <li><a href="#Feature"><span>CARRIERの特徴</span></a></li>
    <li><a href="#Spec"><span>仕様</span></a></li>
    <li><a href="#Lineup"><span>ラインナップ</span></a></li>
    <li><a href="#Read"><span>注意事項</span></a></li>
  </ul>
  `;

const lpNavSp =  `
  <ul class="nav_list_sp menu-drawer__menu">
    <li><a class="menu-drawer__menu-item" href="#Feature">CARRIERの特徴</a></li>
    <li><a class="menu-drawer__menu-item" href="#Spec">仕様</a></li>
    <li><a class="menu-drawer__menu-item" href="#Lineup">ラインナップ</a></li>
    <li><a class="menu-drawer__menu-item" href="#Read">注意事項</a></li>
  </ul>
  `;

class Blocks {
  constructor () {
    this.bodyLp();
    this.headNav();
    this.linkUrl();
    this.headScroll();
    this.mainvisual();
    this.readBtn();
  }

  bodyLp () {
    $('body').addClass('is--lp');
  }

  headNav () {
    $('.list-menu--inline').replaceWith(lpNav);
    $('.menu-drawer__menu').replaceWith(lpNavSp);
    if( mq.matches ) {
      $('.menu-drawer__menu-item').on('click', function(){
        $('#Details-menu-drawer-container summary').trigger('click');
      });
    }
  }
  
  linkUrl() {
    $('.header_heading-link').attr('href', '#');
    $('footer .bottom_wrap .buy').attr('href', '#Lineup');
  }

  headScroll () {
    if( mq.matches ) {      
      $(w).on('load scroll', function(){
        let scroll = $(this).scrollTop();
        if ( scroll >= 100) {
          $('header').addClass('scroll');
        } else {
          $('header').removeClass('scroll');
        }
      });
    } else {
      $(w).on('load scroll', function(){
        let scroll = $(this).scrollTop();
        let mvH = $('.lp-mainvisual').height();
        if ( scroll >= mvH) {
          $('header').addClass('scroll');
        } else {
          $('header').removeClass('scroll');
        }
      });
    }
  }

  mainvisual () {
    const Mv = d.querySelector('#shopify-section-lp-mainvisual');
    w.addEventListener('load', function(){
      Mv.classList.add('loaded');
    });
  }

  readBtn () {
    $('.slide_trigger').on('click', function(){
      $(this).toggleClass('open');
      $(this).parent('h4').next('.slide_wrap').slideToggle();
    });
  }
}

const init = () => {
  new Blocks;
};

export default function LP () {
  $(init)
}